export default __webpack_public_path__ + "static/media/multiple_matrix_colour.6348fb2a.svg";